var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,75.543c0,39.39,67.91,60,135,60s135-20.61,135-60C270-3.236,0-3.236,0,75.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,165.543c-48.549,0-135-14.223-135-60v30c0,39.3,67.8,60,135,60s135-20.7,135-60v-30    C270,151.277,183.957,165.543,135,165.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,285.543c-67.2,0-135-20.7-135-60v30c0,39.3,67.8,60,135,60s135-20.7,135-60v-30    C270,264.843,202.2,285.543,135,285.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,345.543c-67.2,0-135-20.7-135-60v30c0,39.3,67.8,60,135,60s135-20.7,135-60v-30    C270,324.843,202.2,345.543,135,345.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,405.543c-67.2,0-135-20.7-135-60v30c0,39.3,67.8,60,135,60s135-20.7,135-60v-30    C270,384.843,202.2,405.543,135,405.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,465.543c-67.2,0-135-20.7-135-60v30c0,39.3,67.8,60,135,60s135-20.7,135-60v-30    C270,444.843,202.2,465.543,135,465.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135,225.543c-67.2,0-135-20.7-135-60v30c0,45.777,86.451,60,135,60c58.198,0,116.7-15.601,131.4-45    c2.399-4.5,3.6-9.6,3.6-15v-30C270,204.843,202.2,225.543,135,225.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375,465.543c-27.612,0-55.056-3.684-78.127-10.53c-2.985,9.333-8.145,17.653-15.007,25.054    c25.4,10.214,59.323,15.476,93.135,15.476c67.2,0,137-20.7,137-60v-30C512,444.843,442.2,465.543,375,465.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375,345.543c-26.375,0-52.606-3.365-75-9.607c0,16.857,0,13.234,0,30.092c22.401,6.229,48.669,9.516,75,9.516    c67.2,0,137-20.7,137-60v-30C512,331.32,423.549,345.543,375,345.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375,405.543c-26.455,0-52.551-3.567-75-9.875c0,11.118,0,4.385,0,30.152c22.361,6.313,48.56,9.723,75,9.723    c48.957,0,137-14.267,137-60v-30C512,384.843,442.2,405.543,375,405.543z",
    "data-original": "#000000",
    style: {}
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300,205.755v99.842c22.405,6.37,48.508,9.946,75,9.946c67.09,0,137-20.61,137-60    C512,200.698,379.446,184.198,300,205.755z",
    "data-original": "#000000",
    style: {}
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.16f16f0845d6e6ff46c7dac3986a3d81.svg";
export { ForwardRef as ReactComponent };